import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { TopBanner } from './components/TopBanner';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { DeviceMarketplace } from './components/DeviceMarketplace';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
import { CpuIcon } from 'lucide-react';
import { Dashboard } from './pages/Dashboard';
import { Signup } from './pages/Signup';
import { Shop } from './pages/Shop';
import { Plans } from './pages/Plans';
import { Business } from './pages/Business';
import { Coverage } from './pages/Coverage';
import { useScreenInit } from './useScreenInit';
import { ThemeProvider } from './components/ThemeProvider';
function LandingPage() {
  return <div className="min-h-screen bg-white dark:bg-[#000000] text-[#333333] dark:text-gray-100 selection:bg-[#13E200] selection:text-black transition-colors duration-300" data-id="element-0" data-mp="28tw62tsgwo4i">
      <TopBanner data-id="element-1" data-mp="23ti7e2craqj5" />
      <Navbar data-id="element-2" data-mp="3ik7fce9tu7pl" />

      <main className="pt-[133px]" data-id="element-3" data-mp="3ikr0s4yore8d">
        <Hero data-id="element-4" data-mp="3ijpbowku4r7n" />
        <Pricing data-id="element-5" data-mp="3ihv1ac76whht" />
        <DeviceMarketplace data-id="element-6" data-mp="3mlj8uuvtnd32" />
      </main>

      <Footer data-id="element-7" data-mp="3mk86mzi0yde2" />
    </div>;
}
export function App() {
  useScreenInit();
  return <ThemeProvider data-id="element-8" data-mp="3rbzngibdp4r0">
      <BrowserRouter data-id="element-9" data-mp="3rdkkqfp2v1sk">
        <Routes data-id="element-10" data-mp="3recedkz46pg7">
          <Route path="/" element={<LandingPage data-id="element-12" data-mp="6hpnd64cbd2" />} data-id="element-11" data-mp="5yjetptzbev" />
          <Route path="/signup" element={<Signup data-id="element-14" data-mp="82ovg3doih9" />} data-id="element-13" data-mp="4n725ibkvc5" />
          <Route path="/dashboard" element={<Dashboard data-id="element-16" data-mp="2zm4xqkjlzd1t" />} data-id="element-15" data-mp="2zld0746gb58w" />
          <Route path="/shop" element={<Shop data-id="element-18" data-mp="33mow1rfx4mpj" />} data-id="element-17" data-mp="2zmwggus3xgao" />
          <Route path="/plans" element={<Plans data-id="element-20" data-mp="33ngfy505kvzz" />} data-id="element-19" data-mp="33m5bs42spm8c" />
          <Route path="/business" element={<Business data-id="element-22" data-mp="38m1elzzrb7mb" />} data-id="element-21" data-mp="33orhrza1ftog" />
          <Route path="/coverage" element={<Coverage data-id="element-24" data-mp="38kgmsi4tu2s5" />} data-id="element-23" data-mp="38kqd66tsabyd" />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>;
}